var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner-area2',{attrs:{"banner":_vm.banners,"logo":"images/Sinaloaennumeros1.png","clase":"sinaloaNumeros"}}),_vm._v(" "),_c('box-container',{attrs:{"data":_vm.sinnumeros,"visible":false,"show":'sinaloaennumeros_show'}}),_vm._v(" "),_c('boletin-container')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23622fa4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/sinaloaNumeros.vue
// module id = qAdi
// module chunks = 0